function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useObservabilityConfig, usePerformanceMonitorTrack, useProject } from "@sail/observability";
import { useMemoizedValue, useUpdatedRef } from "@sail/react";
import { useCallback, useEffect, useRef, useState } from "react";
import useLogFetch from "./useLogFetch";
import fullFetch from "../shared/fetch/fullFetch";
import { REQUEST_SOURCE_HEADER, getRequestSourceHeader, getRequestSourceInformation } from "../shared/requestSource";
import useDataConfig from "../../public/useDataConfig";
const initial = {
    loading: false,
    error: undefined,
    status: undefined,
    headers: undefined,
    data: undefined
};
const loading = {
    loading: true,
    error: undefined,
    status: undefined,
    headers: undefined,
    data: undefined
};
export default function useLazyBaseFetch(url, options, format) {
    var _useObservabilityConfig;
    const dataConfig = useDataConfig();
    const optionsMemo = useMemoizedValue(options);
    var _dataConfig_fetch;
    const fetchRef = useUpdatedRef((_dataConfig_fetch = dataConfig.fetch) !== null && _dataConfig_fetch !== void 0 ? _dataConfig_fetch : globalThis.fetch);
    const logFetch = useLogFetch(dataConfig.observability);
    const project = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const performanceMonitorTrack = usePerformanceMonitorTrack();
    const [value, setValue] = useState(initial);
    const [called, setCalled] = useState(0);
    // eslint-disable-next-line react-hooks/refs
    if (useRef(options.retry).current !== options.retry) {
        throw new ReferenceError('You are changing the reference of the `retry` function across renders, which is not allowed to prevent infinite re-renders');
    }
    const requestSourceInformation = getRequestSourceInformation({
        service,
        project,
        component: optionsMemo.component
    });
    const requestSource = getRequestSourceHeader(requestSourceInformation);
    useEffect(()=>{
        if (called) {
            const abortController = new AbortController();
            const fetch = fetchRef.current;
            const end = performanceMonitorTrack(`Fetch: ${url}`);
            _async_to_generator(function*() {
                const fullOptions = _object_spread_props(_object_spread({}, optionsMemo), {
                    headers: _object_spread({
                        [REQUEST_SOURCE_HEADER]: requestSource
                    }, optionsMemo.headers),
                    signal: abortController.signal
                });
                setValue(loading);
                const newValue = yield fullFetch(url, fullOptions, optionsMemo.prepareFetch ? optionsMemo.prepareFetch(fetch) : fetch, format, logFetch);
                end();
                if (newValue !== null) {
                    setValue(newValue);
                }
            })();
            return ()=>{
                end();
                abortController.abort();
            };
        }
    }, [
        called,
        fetchRef,
        url,
        optionsMemo,
        format,
        logFetch,
        requestSource,
        performanceMonitorTrack
    ]);
    const callback = useCallback(()=>{
        setCalled((called)=>called + 1);
        setValue(loading);
    }, []);
    return [
        callback,
        useMemoizedValue(_object_spread({
            called: called > 0
        }, value))
    ];
}

//# sourceMappingURL=useLazyBaseFetch.js.map